import { axiosFactory, axiosPostFactory, axiosFormFactory } from './axios-factory'
export default {
    // 获取资源详情
    getResource: (params) => axiosFactory({
        url: 'res/getResource',
        params,
        //?resourceId=2ba1771c-2c01-11ec-a336-fa163ecfd1b0
    }),
    //获取资源列表
    listResource: (params) => axiosFactory({
        url: 'res/listResource',
        params,
        //? sortType = view_count : asc, create_time: asc & pageNum=2& pageSize=10& type=1
    }),
    //获取评论列表
    listComment: (params) => axiosFactory({
        url: 'res/listComment',
        params,
        //?sortType = create_time : asc & pageNum=1 & pageSize=1
    }),
    // 添加评论
    addComment: (params) => axiosFactory({
        url: 'res/addComment',
        params,
        //?resourceId=222222222222222&content=%E8%BF%99%E6%98%AF%E4%B8%80%E4%B8%AA%E8%AF%84%E8%AE%BA&toCommentId=1111111
    }),
    // 视频资源
    getCountResource: (params) => axiosFactory({
        url: 'res/countResource',
        params,
    }),
    subjectDistribution: (params) => axiosFactory({
        url: 'res/subjectDistribution',
        params
    }),
    //获取学段
    getlistPhase: (params) => axiosFactory({
        url: 'res/listPhase',
        params
    })
}